import messages from '../messages';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Banner } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import {
  CalculateIcon,
  AlertCriticalIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';
import React from 'react';
import useIntl from '../../../hooks/useIntl';

const AutoCalculateModal = (props) => {
  const { open, closeModal, onSubmit, title, body, warningText } = props;
  const intl = useIntl();

  return (
    <Modal
      open={open}
      onClose={closeModal}
      icon={<CalculateIcon color="primary" />}
      title={title || intl.formatMessage(messages.autoCalculationModalHeader)}
      actionsProps={[
        {
          children: intl.formatMessage(messages.autoCalculationCancelButton),
          onClick: closeModal,
        },
        {
          children: intl.formatMessage(messages.autoCalculationConfirmButton),
          submitButton: true,
          onClick: onSubmit,
        },
      ]}
      ModalProps={{
        PaperProps: {
          sx: {
            width: {
              xs: 'calc(100% - 32px)',
              sm: 437,
            },
            maxHeight: 'calc(100vh - 100px)',
          },
        },
      }}
    >
      <>
        <Typography sx={{ mb: 2, display: 'block' }}>
          {body || intl.formatMessage(messages.autoCalculationModalBody1)}
        </Typography>
        <Typography sx={{ mb: 2, display: 'block' }}>
          {intl.formatMessage(messages.autoCalculationModalBody2)}
        </Typography>
        <Banner
          color="warning"
          icon={<AlertCriticalIcon color="warning" />}
          text={
            warningText ||
            intl.formatMessage(messages.autoCalculationModalWarning)
          }
          hasBorder={false}
          TypographyProps={{
            sx: {
              whiteSpace: 'normal',
            },
          }}
        />
      </>
    </Modal>
  );
};

export default AutoCalculateModal;
